export type SafetyScanLineageInput = {
  reportId?: string | null;
  scanId?: string | null;
  durableReportId?: string | null;
  reportFamilyId?: string | null;
  derivedFromReportId?: string | null;
  predecessorReportId?: string | null;
  scopeStart?: string | null;
  scopeEnd?: string | null;
};

function dateKey(value?: string | null): string {
  const raw = String(value || '').trim();
  const direct = raw.match(/^(\d{4}-\d{2}-\d{2})/);
  if (direct) return direct[1];
  const parsed = new Date(raw);
  return Number.isNaN(parsed.getTime()) ? raw : parsed.toISOString().slice(0, 10);
}

export function buildLogicalScanKey(input: SafetyScanLineageInput): string {
  const windowKey = [dateKey(input.scopeStart), dateKey(input.scopeEnd)].filter(Boolean).join('::');
  if (windowKey.includes('::')) return windowKey;
  const reportId = String(input.reportId || input.scanId || '').trim();
  if (reportId) return reportId;
  const lineage = [input.reportFamilyId, input.durableReportId, input.derivedFromReportId, input.predecessorReportId]
    .map((value) => String(value || '').trim())
    .find(Boolean);
  return lineage || 'scan';
}
